import { createSlice } from '@reduxjs/toolkit'
import set from './reducers/setMe'
import setMain from './reducers/setMainContentLoaded'
import setUserLogged from './reducers/setLogged'
import setField from './reducers/setMeField'
import setMeSignature from './reducers/setMeSignature'

export const slice = createSlice({
  name: 'me',
  initialState: {
    me: {},
    logged: false,
    mainContentLoaded: false,
  },
  reducers: {
    setMe: set,
    setSignature: setMeSignature,
    setMainContent: setMain,
    setLogged: setUserLogged,
    setMeField: setField,
  },
})

export const { setMe, setMainContent, setAccessToken, setLogged, setMeField, setSignature } = slice.actions

export default slice.reducer
